import React from "react";
import InnerServicesAreaItem from "./InnerServicesAreaItem";

const InnerServicesArea = () => {
  const inner_services = [
    {
      src: "/img/icon/inner_services_icon01.png",
      url: "/services-details",
      title: "Meubelstoffering",
      desc: "Professioneel stofferen van banken, stoelen en fauteuils met hoogwaardige stoffen en materialen.",
    },
    {
      src: "/img/icon/inner_services_icon02.png",
      url: "/services-details",
      title: "Herstoffering",
      desc: "Geef uw oude meubels een tweede leven door vakkundige herstoffering, volledig naar wens uitgevoerd.",
    },
    {
      src: "/img/icon/inner_services_icon03.png",
      url: "/services-details",
      title: "Projectstoffering",
      desc: "Complete stoffering van zakelijke ruimtes zoals kantoren, horeca en winkels, gericht op duurzaamheid en maatwerk.",
    },
    {
      src: "/img/icon/inner_services_icon04.png",
      url: "/services-details",
      title: "Custom Maatwerk",
      desc: "Speciale stoffering op maat voor unieke projecten en interieurs, volledig afgestemd op uw wensen.",
    },
    {
      src: "/img/icon/inner_services_icon05.png",
      url: "/services-details",
      title: "Advies & Ontwerp",
      desc: "Persoonlijk advies bij keuze van stoffen, kleuren en ontwerpen om uw project perfect te laten aansluiten bij uw interieur.",
    },
    {
      src: "/img/icon/inner_services_icon06.png",
      url: "/services-details",
      title: "Reparatie & Restauratie",
      desc: "Vakkundige reparaties en restauraties om uw meubels te behouden en hun levensduur te verlengen.",
    },
    {
      src: "/img/icon/inner_services_icon07.png",
      url: "/services-details",
      title: "Zitcomfort Verbetering",
      desc: "Professionele verbetering van vering, schuim en kussens voor optimaal zitcomfort.",
    },
    {
      src: "/img/icon/inner_services_icon08.png",
      url: "/services-details",
      title: "Stoffering Caravan & Boot",
      desc: "Stoffering en herstoffering van caravans, campers en boten voor zowel interieur als exterieur toepassingen.",
    },
  ];

  return (
    <section className="inner-services-area pt-110 pb-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="section-title title-style-two text-center mb-60">
              <span className="sub-title">Onze Services</span>
              <h2 className="title">Vakmanschap in Stoffering en Herstoffering</h2>
            </div>
          </div>
        </div>

        <div className="inner-services-item-wrap">
          <div className="row justify-content-center">
            {inner_services.map((x, index) => (
              <div key={index} className="col-xl-3 col-lg-4 col-md-6 col-sm-8">
                <InnerServicesAreaItem item={x} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InnerServicesArea;
